const DEFAULT_LANGUAGE = 'en';

const DEFAULT_PATHS = {
    LOGIN: locale => `/${locale}/auth/login`,
    BOOKING_VIEW: (locale, reference) => `/${locale}/bookings/${reference}/view`
};

const ON_THE_BEACH_PATHS = {
    LOGIN: `/${DEFAULT_LANGUAGE}/on-the-beach/login`,
    BOOKING_VIEW: `/${DEFAULT_LANGUAGE}/on-the-beach/booking/view`
};

export default function appConfigLocation($locationProvider, $urlRouterProvider, cacheServiceProvider) {
    'ngInject';
    //TODO: rename component to app.config
    $locationProvider.html5Mode(true).hashPrefix('!');

    $urlRouterProvider.otherwise(function($injector) {
        const cacheService = $injector.get('cacheService');
        const locale = cacheService.get('customer').language || DEFAULT_LANGUAGE;
        const bookingReference = cacheService.get('bookingReference');

        if (!bookingReference) {
            const isOnTheBeach = window.location.pathname.includes('on-the-beach');
            if (isOnTheBeach) return ON_THE_BEACH_PATHS.LOGIN;
            return DEFAULT_PATHS.LOGIN(locale);
        }

        const isOnTheBeachBooking = cacheService.get('onTheBeachBooking');
        if (isOnTheBeachBooking) return ON_THE_BEACH_PATHS.BOOKING_VIEW;
        return DEFAULT_PATHS.BOOKING_VIEW(locale, bookingReference);
    });
}



// WEBPACK FOOTER //
// ./client/app/app.config.locations.js